import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './SelectedFilterNodeNegation.less';

const I18N = defineMessages({
  TITLE: {
    id: 'filter.selectedFilters.negate.title',
    defaultMessage: 'Negate this filter condition',
    description: 'title text for negate filter button in selected filters box',
  },
});

class SelectedFilterNodeNegation extends React.PureComponent {
  render() {
    const {intl, isNegated} = this.props;
    return (
      <i
        onClick={this.handleNegateClick}
        onKeyDown={this.handleNegateKeyDown}
        tabIndex='0'
        role='button'
        title={utils.TranslateUtils.translate(I18N.TITLE, intl)}
        className={classNames(
          'fas',
          'fa-exclamation',
          styles.dlSelectedFilterNodeNegation,
          {[styles.dlNegated]: isNegated}
        )}
      />
    );
  }
}

SelectedFilterNodeNegation.displayName = 'SelectedFilterNodeNegation';

SelectedFilterNodeNegation.propTypes = {
  intl: intlShape.isRequired,
  isNegated: PropTypes.bool,
};

SelectedFilterNodeNegation.defaultProps = {
  isNegated: false,
};

export default injectIntl(SelectedFilterNodeNegation);
